import styled from "styled-components";


export const Container = styled.main`
  .pg_overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 9999;
  }

  .inner{
    width: 100%;
    /* max-width: 420px; */
    max-width: 560px;
    padding-top: 100px;
    padding-bottom: 100px;

    .bx{
      + .bx{
        margin: 48px 0 0;
      }

      &.product{
        .form_label{
          &:nth-child(1){
            width: 230px;
            text-align: center;
          }
          &:nth-child(2){
            padding: 0 10px;
          }
          span{
            margin: 2px 0 0;
            font-size: inherit;
          }
        }

        ul{
          li{
            display: flex;
            align-items: center;  
            button{
              width: 230px;
              height: 46px;
              padding: 0 10px;
              border-radius: 6px;

              &.active{
                border-color: var(--main);
                color: var(--main_hover);
              }
            }
            p{
              flex: 1;
              padding: 0 10px;
              text-align: center;
            }

            + li{
              margin-top: 12px;
            }
          }
        }
      }

      &.payment_amount{
        .msg{
          padding: 12px 0 0;
          line-height: 1.5;
        }
      }

      &.payment_type{
        button{
          width: 100%;
          height: 46px;
          border-radius: 6px;

          &.active{
            border-color: var(--main);
            color: var(--main_hover);
          }

          + button{
            margin-left: 12px;
          } 
        }
      }
    }

    .btn_done{
      width: 100%;
      height: 46px;
      margin: 60px 0 0;
      border-radius: 6px;
      font-family: 'PretendardBold';
    }
  }


  @media screen and (min-width: 501px) {
    /* section{
      width: 360px;
      margin: 0 auto;
    } */
  }

  @media (max-width: 500px) {
    /* section{
      width: 100%;
    } */
  }
`